module.exports = __webpack_public_path__ + "static/media/button-yellow.69d2b24a.png";